module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_null@2x.bfa6772f.png";